import {i18n} from '@yourcoach/i18n';

import type {AccountApiModel} from '../../../api/account';

import {accountStore} from '../../../api/account';
import {alert} from '../../../components/alert';
import {TestID} from '../../../utils/test-utils/data-test-id';
import {askToFillPrivateProfileIfNeeded} from '../../sync-private-profile';
import {COMMAND} from '../utils';

export const accountMakePrimary = async (account: AccountApiModel) => {
  if (account.primary) {
    alert.show({
      /**
       * @i18n_parser
       *
       * t('shared:services.entity_action.account.make_primary.message.email')
       * t('shared:services.entity_action.account.make_primary.message.phone')
       */
      message: i18n.t(
        `shared:services.entity_action.account.make_primary.message.${account.type}`,
      ),
      testID: TestID.accounts.alert.primary_account.container,
    });

    return COMMAND.CANCEL;
  }

  const shouldPerformRequest = await alert.show<boolean>({
    buttons: [
      {
        label: i18n.t('shared:no'),
        onAwaitableClick: resolve => resolve(false),
        testID: TestID.accounts.alert.secondary_account.no,
      },
      {
        label: i18n.t('shared:yes'),
        onAwaitableClick: resolve => resolve(true),
        scheme: 'primary',
        testID: TestID.accounts.alert.secondary_account.yes,
      },
    ],
    message:
      /**
       * @i18n_parser
       *
       * t('shared:services.entity_action.account.make_primary.confirm.email')
       * t('shared:services.entity_action.account.make_primary.confirm.phone')
       */
      i18n.t(
        `shared:services.entity_action.account.make_primary.confirm.${account.type}`,
        {
          account: account.value,
        },
      ),
    testID: TestID.accounts.alert.secondary_account.container,
  });

  if (!shouldPerformRequest) {
    return COMMAND.CANCEL;
  }

  const primaryAccount = await accountStore.makePrimary(account);

  askToFillPrivateProfileIfNeeded({
    [account.type]: account.value,
  });

  return primaryAccount;
};
